import { brand$ as nwb$ } from '@apiEnabler/ob-common/lib/brands/pbb/natwest'
import { brand$ as nwbi$ } from '@apiEnabler/ob-common/lib/brands/pbb/natwesti'
import { brand$ as rbs$ } from '@apiEnabler/ob-common/lib/brands/pbb/rbs'
import { brand$ as rbsi$ } from '@apiEnabler/ob-common/lib/brands/pbb/rbsi'
import { brand$ as ubn$ } from '@apiEnabler/ob-common/lib/brands/pbb/ulsterbank-north'
import { brand$ as iom$ } from '@apiEnabler/ob-common/lib/brands/pbb/iom'

const { brand, theme } = window.ui

const brandDefinitions = {
  natwest: nwb$,
  natwesti: nwbi$,
  rbs: rbs$,
  rbsi: rbsi$,
  'ulsterbank-north': ubn$,
  iom: iom$,
}

export const brand$ = brandDefinitions[brand]

export function loadBrandAssets() {
  return Promise.all([
    import(
      /* webpackChunkName: "[request]" */
      `@zambezi/sdk-themes/${theme}/theme.min.css`
    ),
    import(
      /* webpackChunkName: "[request]" */
      `@zambezi/sdk-themes/${theme}/icons.js`
    ),
  ])
}
